let ToastEl:HTMLElement;
let ToastTO:number;
let ToastCB:()=>void;
export function ShowToast(el:HTMLElement,duration:number=3000):Promise<void> {
  if(ToastEl) HideToast(ToastEl);
  if(typeof el==="string") el=document.querySelector(el) as HTMLDialogElement;
  ToastEl=el;
  el.classList.add("show");
  ToastTO=window.setTimeout(()=>{
    el.addEventListener("transitionend",ToastTransitionEnd);
    el.style.opacity='0';
  },duration);
  return new Promise((resolve,reject)=>{ToastCB=resolve});
}
function ToastTransitionEnd(e:TransitionEvent) {
  if(ToastEl===e.target && ToastEl.style.opacity==='0') HideToast(ToastEl)
}
export function HideToast(el:HTMLElement) {
  if(!ToastEl || ToastEl !==el) return;
  window.clearTimeout(ToastTO);
  ToastEl.removeEventListener("transitionend",ToastTransitionEnd);
  ToastEl.classList.remove("show");
  ToastEl.style.opacity='';
  ToastEl=null;
  ToastCB();
  ToastCB=null;
}

function MakeToast(tp:"success"|"info"|"warning"|"danger",icon:string, text:string,duration:number) {
  let elDiv=document.createElement("div");
  elDiv.className = "toast alert shadow " + tp;
  elDiv.style.padding = "1rem";
  elDiv.innerHTML="<alvar-icon name='" + icon + "'></alvar-icon> " + (text.split('&').join('&amp;').split('<').join('&lt').split('>').join('&gt;'));
  document.body.appendChild(elDiv);
  window.requestAnimationFrame(()=>{
    window.requestAnimationFrame(()=>{
      ShowToast(elDiv,duration).then(()=>elDiv.remove());
  })});
}

export function ToastSuccess(text:string,duration:number=3000) {
  MakeToast("success","check",text,duration);
}
export function ToastWarning(text:string,duration:number=3000) {
  MakeToast("warning","warning",text,duration);
}
export function ToastDanger(text:string,duration:number=3000) {
  MakeToast("danger","error",text,duration);
}
export function ToastInfo(text:string,duration:number=3000) {
  MakeToast("info","info",text,duration);
}
